<div *ngIf="rating !== null" class="rating-container">
  <span class="empty-stars">
    <ng-container *ngFor="let emptyStarIndex of [1, 2, 3, 4, 5]">
      <ion-icon tappable (click)="onChangeRating(emptyStarIndex)" class="empty" src="/assets/custom-icons/b-star-full.svg"></ion-icon>
    </ng-container>
  </span>
  <span class="full-stars">
    <ng-container *ngFor="let fullStarIndex of [1, 2, 3, 4, 5]">
      <ion-icon
        tappable
        (click)="onChangeRating(fullStarIndex)"
        [class.full]="rating >= fullStarIndex || rating > fullStarIndex - 1"
        [src]="
          '/assets/custom-icons/' +
          (rating >= fullStarIndex ? 'b-star-full' : rating > fullStarIndex - 1 ? 'b-half-star-full' : 'b-star-empty') +
          '.svg'
        "
      ></ion-icon>
    </ng-container>
  </span>
</div>
